import { atom, getDefaultStore, useAtomValue } from 'jotai'

// taskId -> preview image list (for batch tasks)
const store = getDefaultStore()
const generatorPreviewMapAtom = atom<Record<string, string[]>>({})

export const setGeneratorPreview = (
  taskId: string,
  images: string | string[],
) => {
  const next = Array.isArray(images) ? images : [images]
  store.set(generatorPreviewMapAtom, prev => ({ ...prev, [taskId]: next }))
}

export const clearGeneratorPreview = (taskId: string) => {
  store.set(generatorPreviewMapAtom, prev => {
    if (!prev[taskId]) return prev
    const next = { ...prev }
    delete next[taskId]
    return next
  })
}

export const useGeneratorPreview = (taskId?: string) => {
  const map = useAtomValue(generatorPreviewMapAtom, { store })
  return taskId ? map[taskId] : undefined
}
